import { Plugin, PluginKey } from 'prosemirror-state';
import { transformAction } from '../item';
import { createProps } from './props';
import { createStatus } from './status';
import { createView } from './view';
export const key = 'MILKDOWN_PLUGIN_SLASH';
export const createSlashPlugin = (utils, items, placeholder) => {
    const status = createStatus();
    const actions = items.map(transformAction);
    return new Plugin({
        key: new PluginKey(key),
        props: createProps(status, utils, placeholder),
        view: (view) => createView(status, actions, view, utils),
    });
};
//# sourceMappingURL=index.js.map